import { userApiPost } from './apiPost'

export const fetchAlerts = userApiPost('get-alerts')

export const fetchAlert = userApiPost('get-alert')

export const updateAlertStatus = userApiPost('update-alert-status')

export const getProviderAccessCount = userApiPost('get-provider-clients')

export const getClientAccessCount = userApiPost('get-client-providers')

export const fetchAccessLogs = userApiPost('get-logs')

export const fetchProvider = userApiPost('get-provider')

export const fetchClient = userApiPost('get-client')

export const getProviderAccessLogs = userApiPost('get-provider-access-logs')

export const getClientAccessLogs = userApiPost('get-client-access-logs')

export const fetchAlertIndicators = userApiPost('get-alert-event-groups')

export const fetchAlertIndicatorDetail = userApiPost('get-alert-event-group')

export const getAllProvidersByPagination = userApiPost('get-all-providers-pagination')

export const getAllClientsByPagination = userApiPost('get-all-clients-pagination')

export const getProviderDailyLogs = userApiPost('get-provider-daily-logs')
